"use strict";

const afterPaint = () => new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
});

const logo = new Image();
logo.src = "/images/fab-form-logo.svg";

Promise.resolve(typeof logo.decode === "function" ? logo.decode() : undefined)
    .catch(() => undefined)
    .then(afterPaint)
    .then(() => import("./router.js"));
